import React, { useState, useEffect } from 'react';
import { get_bearer_access_log } from '../tools-network';

function formatTimestamp(ts) {
  if (!ts) return '—';
  const d = new Date(ts);
  return d.toLocaleString('sv-SE', {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
}

const RESOURCE_LABELS = {
  bearer: 'Bärardata',
  bearer_audit: 'Ändringshistorik',
  scan_token: 'Armband',
  scans: 'Skanningar',
  user: 'Användardata',
  emergency_contacts: 'Nödkontakter',
};

const BearerAccessLog = ({ loginToken, bearerId }) => {
  const [accessLog, setAccessLog] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const fetchAccessLog = async () => {
    if (!bearerId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await get_bearer_access_log(loginToken, bearerId);
      if (res.success) {
        setAccessLog(res.data || []);
      } else {
        setError(res.msg || 'Kunde inte hämta åtkomstlogg');
      }
    } catch (err) {
      setError('Kunde inte hämta åtkomstlogg');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen && bearerId) {
      fetchAccessLog();
    }
  }, [isOpen, bearerId]);

  return (
    <div className="mt-4 border-2 border-indigo-200 rounded-lg p-4 bg-indigo-50">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between text-left"
      >
        <h4 className="text-sm font-semibold text-indigo-900 flex items-center">
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          Åtkomstlogg
        </h4>
        <svg className={`w-5 h-5 text-indigo-600 transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="mt-3">
          {loading && <p className="text-sm text-gray-500">Laddar...</p>}
          {error && <p className="text-sm text-red-600">{error}</p>}
          {!loading && !error && accessLog.length === 0 && (
            <p className="text-sm text-gray-500 italic">Ingen åtkomst har loggats ännu.</p>
          )}
          {!loading && !error && accessLog.length > 0 && (
            <div className="space-y-2 max-h-72 overflow-y-auto">
              {accessLog.map((entry, idx) => (
                <div key={idx} className="bg-white rounded-md p-2 shadow-sm border border-gray-100 text-sm flex justify-between items-start">
                  <div>
                    <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
                      {RESOURCE_LABELS[entry.resource_type] || entry.resource_type}
                    </span>
                    <span className="text-xs text-gray-500 ml-2">
                      {formatTimestamp(entry.timestamp)}
                    </span>
                    <div className="text-xs text-gray-400 mt-0.5">
                      {entry.endpoint}
                    </div>
                  </div>
                  <span className="text-xs text-gray-500 whitespace-nowrap">
                    {entry.accessor_name || `Användare #${entry.accessor_id}`}
                    {entry.accessor_type && <span className="ml-1 text-gray-400">({entry.accessor_type})</span>}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BearerAccessLog;
